import script from "./WebShopListBase.vue?vue&type=script&lang=ts"
export * from "./WebShopListBase.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__